import React from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
	BatchShipmentDateUpload
} from '../../components/batch-shipment-date/';

class BatchShipmentDateUploadView extends React.Component {

	constructor(props) {
    super(props);

  }

	componentDidMount() {

	}

	render() {
		return (
			<div>
				<Row>
					<Col md="12">
            <BatchShipmentDateUpload />
					</Col>
				</Row>
			</div>
		);
	}
}

export default BatchShipmentDateUploadView;
